export {};
//# sourceMappingURL=IsStrictlyAny.js.map